"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.notify = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useNotifications2 = _interopRequireDefault(require("./useNotifications"));

var notify = function notify() {
  return null;
};

exports.notify = notify;

var setNotify = function setNotify(notifyFn) {
  exports.notify = notify = notifyFn;
};

var NotifySetter = function NotifySetter(_ref) {
  var children = _ref.children;

  var _useNotifications = (0, _useNotifications2.default)(),
      notify = _useNotifications.notify;

  setNotify(notify);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};

NotifySetter.propTypes = {
  children: _propTypes.default.node
};
NotifySetter.displayName = 'NotifySetter';
var _default = NotifySetter;
exports.default = _default;